import { SCREEN_RESIZE } from '../../constant';

const screenResizeAction = (width, height, fontSize) => ({
  type: SCREEN_RESIZE,
  data: { width, height, fontSize },
});

export { screenResizeAction };
